<template>
  <div style="padding: 0; margin: 0; height: 100%;">
    <div v-loading="loading" element-loading-text="加载中..." class="app-container">
      <el-card shadow="never" :body-style="{ padding: 0 }" class="sticky-container">
        <template slot="header">
          <el-row :gutter="10" class="filter-container">
            <el-col :xs="24" :sm="6">
              <el-input v-model="queryParams.keyword" class="filter-item" placeholder="用户昵称、手机号或分享码" clearable />
            </el-col>
            <el-col :xs="24" :sm="3">
              <el-select v-model="queryParams.userGrade" class="filter-item" placeholder="用户身份" clearable>
                <el-option v-for="(item, index) in memberLevel" :key="index" :label="item.levelName" :value="item.id" />
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="3">
              <el-select v-model="queryParams.consumerLevel" class="filter-item" placeholder="消费等级" clearable>
                <el-option v-for="(item, index) in consumeLevel" :key="index" :label="item.levelName" :value="item.id" />
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="3">
              <el-select v-model="queryParams.status" class="filter-item" placeholder="状态" clearable>
                <el-option label="禁用" :value="0" />
                <el-option label="启用" :value="1" />
              </el-select>
            </el-col>
            <el-col :xs="24" :sm="6">
              <el-button class="filter-item" type="primary" icon="el-icon-search" @click="handleFilter">查找</el-button>
            </el-col>
          </el-row>
        </template>

        <el-table v-sticky-header stripe fit highlight-current-row :data="list" header-cell-class-name="table-header-cell">
          <el-table-column label="序号" width="60" align="center" type="index" class-name="table-header-cell">
            <template slot-scope="scope">
              <span>{{ (scope.$index + 1) + (queryParams.page - 1) * queryParams.limit }}</span>
            </template>
          </el-table-column>
          <el-table-column label="用户昵称" prop="nickName" min-width="120">
            <template slot-scope="{row}">{{ row.nickName | filterMemberName }}</template>
          </el-table-column>
          <el-table-column label="手机号" prop="mobile" min-width="120" />
          <el-table-column label="分享码" prop="shareCode" min-width="80" />
          <el-table-column label="身份等级" prop="gradeName" align="center" width="100" />
          <el-table-column label="消费等级" prop="consumerName" align="center" width="100" />
          <el-table-column label="邀请人" prop="inviterName" min-width="120" />
          <el-table-column label="注册时间" prop="createTime" min-width="150" />
          <el-table-column align="center" width="80" fixed="right">
            <template slot-scope="{row}">
              <el-dropdown trigger="click">
                <span class="el-dropdown-link">
                  操作<i class="el-icon-arrow-down el-icon--right" />
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item @click.native="handleDetail(row.id)">用户详情</el-dropdown-item>
                  <el-dropdown-item divided @click.native="handleFundRecord(row.id)">更改推荐人</el-dropdown-item>
                  <el-dropdown-item divided @click.native="handleFundRecord(row.id)">更改推荐人</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </template>
          </el-table-column>
        </el-table>
        <pagination :total="total" :page.sync="queryParams.page" :limit.sync="queryParams.limit" @pagination="fetchData" />
      </el-card>
    </div>

    <el-dialog title="用户详情" top="5vh" width="600px" :visible.sync="detailDialog">
      <member-detail :member-id="memberId" />

      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click="detailClose">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getMemberList } from '@/api/member'
import { StickyHeader } from '@cell-x/el-table-sticky'
import Pagination from '@/components/Pagination'
import memberDetail from './detail'

export default {
  name: 'MemberIndex',
  components: { Pagination, memberDetail },
  filters: {
    filterMemberName: (memberName) => {
      return memberName || '慧生活用户'
    }
  },
  directives: {
    StickyHeader: new StickyHeader({ offsetTop: 0, offsetBottom: 0 }).init()
  },
  data() {
    return {
      list: [],
      total: 0,
      detail: null,
      loading: false,
      memberLevel: [
        { id: 0, levelName: '未授权' },
        { id: 1, levelName: '粉丝' },
        { id: 2, levelName: '会员' },
        { id: 3, levelName: 'SVIP' }
      ],
      consumeLevel: [
        { id: 0, levelName: '非消费者' },
        { id: 1, levelName: '消费者' },
        { id: 2, levelName: '消费商' },
        { id: 3, levelName: '店长' },
        { id: 4, levelName: '分公司' }
      ],
      queryParams: {
        keyword: '',
        userGrade: '',
        consumerLevel: '',
        status: '',
        page: 1,
        limit: 20
      },
      detailDialog: false,
      memberId: ''
    }
  },
  created() {
    this.fetchData()
  },
  methods: {
    handleFilter() {
      this.queryParams.page = 1
      this.fetchData()
    },
    fetchData() {
      this.loading = true
      getMemberList(this.queryParams).then(response => {
        this.list = response.records
        this.total = response.total
      }).finally(() => {
        setTimeout(() => {
          this.loading = false
        }, 1000)
      })
    },
    handleDetail(memberId) {
      // getMemberDetail(memberId).then(response => {
      //   console.log(response)
      // })
      this.memberId = memberId
      this.detailDialog = true
    },
    detailClose() {
      this.memberId = ''
      this.detailDialog = false
    },
    handleFundRecord(memberId) {
    }
  }
}
</script>

<style lang="scss" scoped>
::v-deep {
  .el-card__header {
    padding-bottom: 0;
  }
}
</style>
